import React from "react";
import { Image } from "react-bootstrap";

export const Loader = () => {
  return (
    <div className="load-container">
      <Image src={process.env.REACT_APP_S3_IMAGE_PATH + "loader.gif"} fluid />
    </div>
  );
};
export const ScreenLoading = () => {
  return (
    <div className="screenLoader">
      <Loader />
    </div>
  );
};
export const SectionLoading = () => {
  return (
    <div className="scLoader">
      <Loader />
    </div>
  );
};
export const NotFound = (props) => {
  return <div className="scLoader">{props.message}</div>;
};
